(function() {
    'use strict';

    module.exports = {
        checkPreselectedParams: function(dedupId, providerHotelId, providerId) {
            return !this.isNullOrUndefined(dedupId) && !this.isNullOrUndefined(providerHotelId) && !this.isNullOrUndefined(providerId);
        },

        preselectedParameters: function() {
            const accommodationPostBooking = Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'));
            const preselectedAccommodation = Odigeo.Utils.parseJson(Odigeo.Session.get('preselectedAccommodation'));
            if (accommodationPostBooking && !this.isNullOrUndefined(preselectedAccommodation)) {
                const dedupId = preselectedAccommodation.dedupId;
                const providerHotelId = preselectedAccommodation.providerHotelId;
                const providerId = preselectedAccommodation.providerId;
                if (this.checkPreselectedParams(dedupId, providerHotelId, providerId)) {
                    return `?dedupId=${dedupId}&providerHotelId=${providerHotelId}&providerId=${providerId}`;
                }
            }
            return '';
        },

        isNullOrUndefined: function(param) {
            return Odigeo._.isNull(param) || Odigeo._.isUndefined(param);
        },
    };
}());
